<div class="m-t-5 m-t-4-s flex flex-justify-between">
    <p class="h3">{{'Share your wishlist'|translate}}</p>
    <button class="bg-col-5 b-radius-max pos-relative ratio-1-1"
            [style.width.rem]="2.5"
            role="button"
            aria-label="Close"
            (click)="close()">
        <i class="flex flex-middle flex-justify-center top-0 left-0 right-0 bottom-0 pos-absolute icon-close"
           aria-hidden="true"></i>
    </button>
</div>

<!-- content -->
<div class="m-t-3 m-t-4-s"
     modalBody>
    <p class="m-b-12 m-b-10-s p1 col-11 lh-2"
       
       *iCms="'description' of content"></p>

    <wishlist-share-form></wishlist-share-form>
</div>
